import { NextSeo } from 'next-seo';
import TermsPage from '_components/composed/pages/TermsPage';

export default function Terms() {
  return (
    <>
      <NextSeo title="Terms" />
      <TermsPage />
    </>
  );
}
